<template>
  <div class="container--blog">
    <nav class="breadcrumbs">
      <div class="container">
        <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
      </div>
    </nav>

    <div class="blogArticle">
      <div class="container">
        <div class="row">

        <div class="col-12 col-xs-12">
          <h1 v-html="postTitle" />
          <BlogCategoryList :categories="post.categories" v-if="post.categories" class="cat" />
        </div>

        <div class="col-lg-8 col-xs-12">
          <!--<figure class="figure">
            <img :src="getThumbnail(post)" alt="" class="img-fluid" />
          </figure>

          <div class="col-xs-12">
            <div class="blogArticle--intro" v-html="post.excerpt.rendered" />
          </div>-->

          <div class="col-xs-12">
            <div class="blogArticle--content" v-html="getContent(post)" />
          </div>
        </div>

        <div class="offset-lg-1 col-lg-3 col-xs-12">
          <aside class="blogArticle--aside">
            <p>
              <strong>Beitrag teilen</strong>
            </p>
            <Share />
            <hr />
            <div v-if="categories">
              <p>
                <strong>Kategorien</strong>
              </p>
              <BlogCategoryList class="cat" :categories="categories" v-if="categories" :arrows="true" />
              <hr />
            </div>

            <div v-if="tags">
              <p>
                <strong>Entdecken</strong>
              </p>
              <BlogCategoryList class="tag" :categories="tags" v-if="tags" :isTags="true" />
            </div>
          </aside>
        </div>
        </div>
      </div>

      <section class="bg-lightGray mb-0">
        <div class="container">
          <div class="row">
          <div class="col-12 col-xs-12">
            <h2>
              <strong>Das könnte Sie interessieren</strong><br />
              Neuigkeiten, Tipps und Tricks
            </h2>
            <div class="related-blog-posts">
              <div class="row">
                <div
                  class="col-lg-4 col-sm-6 col-xs-12 mb-4"
                  v-for="(related, i) in post[`jetpack-related-posts`]"
                  :key="related.title"
                  v-if="i < showItems"
                  >
                  <article :key="related.id" class="blogpost bg-white mb-0 h-100" :id="`article-${related.id}`">
                    <div class="blogpost--item blogpost--item-alt">
                      <div class="row">
                        <div class="col-12 col-xs-12">
                          <figure class="figure p-0 m-0">
                            <nuxt-img :src="related.img.src" :alt="related.img.alt_text" class="img-fluid" />
                          </figure>
                        </div>
                        <div class="p-4 col-12">
                          <div class="blogpost--header">
                            <p class="cat" v-html="related.context" />
                            <p class="text-end date" v-html="convertDate(related.date)" v-if="related.date" />
                          </div>
                          <h3 v-html="related.title" />
                          <div v-html="related.excerpt"></div>
                          <p>
                            <nuxt-link :to="`/${linkBase}/${getRelatedLink(related)}`" class="btn btn-blank btn-arrow">
                              Weiterlesen
                            </nuxt-link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>

              <div
                class="readmore d-flex justify-content-center"
                v-if="showItems < post[`jetpack-related-posts`].length"
              >
                <div class="row">
                  <div class="col-12 col-xs-12">
                    <button class="btn btn-secondary" @click="setShowItems(post[`jetpack-related-posts`].length)">
                      Mehr laden
                    </button></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <!--{{post.slug}}-->
      <!-- <div v-html="getContent(post)"></div>-->

      <!-- <pre>{{ post }}</pre>-->
    </div>
  </div>
</template>

<script>
import { useBlogStore } from '~/stores/blog';
import { useContext, computed, ref } from '@nuxtjs/composition-api';
import PostCard from '~/components/Blog/PostCard';
import Share from '~/components/Blog/Share';
import { SfBreadcrumbs } from '@storefront-ui/vue';
import BlogCategoryList from '~/components/Blog/CategoryList';

export default {
  name: 'blog-article',
  components: {
    PostCard,
    Share,
    SfBreadcrumbs,
    BlogCategoryList,
  },
  async asyncData({ route, $axios, app }) {
    const { article } = route.params;
    const blogStore = useBlogStore();
    const post = await $axios.$get('/blog-api/' + 'posts/?slug=' + article);
    const categories = await $axios.$get('/blog-api/' + 'categories/');
    const tags = await $axios.$get('/blog-api/' + 'tags/?per_page=100');
    const linkBase = ref('');
    const postTitle = ref('');

    blogStore.setPost(post[0]);
    blogStore.setCategories(categories);
    blogStore.setTags(tags);
    postTitle.value = post[0].title.rendered;

    if (blogStore?.post['postType'] === 'tribe_events') {
      linkBase.value = 'events';
    }
    linkBase.value = 'blog';

    const breadcrumbs = ref([
      {
        text: 'Home',
        link: decodeURIComponent(app.localePath('/')),
      },
      {
        text: 'Blog',
        link: decodeURIComponent(app.localePath('/blog/')),
      },
      {
        text: blogStore.post?.title?.rendered.replace('&amp;', '&').replace('&#8211;', '-') || 'Artikel',
        link: decodeURIComponent(app.localePath(`/${linkBase.value}/${blogStore?.post?.slug}/`)),
      },
    ]);
    return {
      post: post[0],
      categories,
      tags,
      breadcrumbs: breadcrumbs.value,
      linkBase: linkBase.value,
      postTitle: postTitle.value,
    };
  },

  data() {
    return {
      maxItems: 3,
      showTotal: 0,
      showItems: 0,
    };
  },

  setup() {
    const blogStore = useBlogStore();

    const getThumbnail = () => {
      blogStore.getFeaturedImage();
      return blogStore.featuredImage;
    };
    return {
      getThumbnail,
    };
  },
  mounted() {
    setTimeout(() => {
      let recaptchaScript = document.createElement('script');
      recaptchaScript.innerText = `var $ = UIkit.util;`;
      recaptchaScript.innerText += `$.ready(function () { if (!$.$('.uk-gallery-container')) { $.append(document.body, '<div class="uk-scope uk-gallery-container">'); }; });`;
      document.head.appendChild(recaptchaScript);
    }, 3000);
  },
  head() {
    const blogStore = useBlogStore();
    let metaData = {};
    if (typeof blogStore.post.yoast_head_json !== 'undefined' && blogStore.post.yoast_head_json) {
      metaData = blogStore.post.yoast_head_json;  
    } else if(typeof blogStore.event.yoast_head_json !== 'undefined' && blogStore.event.yoast_head_json) {
      metaData = blogStore.event.yoast_head_json;
    } else if (blogStore.postMetadata) {
      metaData = blogStore.postMetadata;
    }

    const scriptTags = [
      {
        src: 'https://cdn.jsdelivr.net/npm/uikit@3.16.19/dist/js/uikit.min.js',
        async: true,
      },
      {
        src: 'https://cdn.jsdelivr.net/npm/uikit@3.16.19/dist/js/uikit-icons.min.js',
        async: true,
      },
    ];
    return {
      // @ts-ignore
      link: [{ rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/uikit@3.16.19/dist/css/uikit.min.css' }],
      script: scriptTags,
      title: metaData.og_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metaData.og_description || '',
        },
        {
          hid: 'robots',
          name: 'robots',
          content: (metaData?.robots?.follow + "," + metaData?.robots?.index).toUpperCase()  || '',
        },
        {
          hid: 'canonical',
          rel: 'canonical',
          href: metaData.canonical || '',
        },
        // og locale, type, title, description, url, og_site_name, og_image
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: metaData.og_locale || '',
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: metaData.og_type || '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: metaData.og_title || '',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: metaData.og_description || '',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: metaData.og_url || '',
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: metaData.og_site_name || '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: metaData.og_image[0]?.url || '',
        },
      ],
    };
  },
  methods: {
    getContent(post) {
      return post?.content?.rendered
        ?.replaceAll('/blog/wp-content/', '/blog-content/wp-content/')
        .replaceAll(
          'https://i0.wp.com/www.papierfischer.de/blog-content/wp-content',
          'https://i0.wp.com/www.papierfischer.de/blog/wp-content/',
        );
    },

    setShowItems(count) {
      const total = this.post[`jetpack-related-posts`].length;

      if (this.showItems + count < total) {
        this.showItems = this.showItems + count;
      } else {
        this.showItems = total;
      }
    },

    getPostDate(related) {
      const date = new Date(related.date);
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: 'numeric',
      };
      return date.toLocaleString('de-DE', options);
    },
    convertDate(date) {
      return date.replaceAll('/', '.');
    },
    getRelatedLink(related) {
      return related?.url?.replaceAll('https://www.papierfischer.de/blog/', '');
    },
  },

  created() {
    this.setShowItems(this.maxItems);
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/blog/wpstyles.scss';
</style>
<style lang="scss" scoped>
@import '~@/assets/scss/blog/blogStyles.scss';

.container {
  padding-top: 10px;
  overflow: visible;
}
.breadcrumbs {
  @media (max-width: $lg) {
    display: none;
  }
}
</style>
